export default "__VITE_ASSET__BCioxMqy__"